
//13
Object.defineProperty(exports, "__esModule", { value: true });

        module.exports.default = require("stylable/runtime").create(
    "root",
    "CircularProgressBar710207378",
    {"root":"CircularProgressBar710207378--root","progressIndicator":"CircularProgressBar710207378--progressIndicator","indicationIconContainer":"CircularProgressBar710207378--indicationIconContainer","statusIndicator":"CircularProgressBar710207378--statusIndicator","arcsContainer":"CircularProgressBar710207378--arcsContainer","foreArc":"CircularProgressBar710207378--foreArc","backArc":"CircularProgressBar710207378--backArc"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/components/circular-progress-bar/CircularProgressBar.st.css
// module id = 1303
// module chunks = 0